import Mv from './Mv'

window.addEventListener('load', () => {
  setTimeout(() => {
    new Mv()
  }, 600)
})


// WEBPACK FOOTER //
// ./src/assets/js/index/entry.js